import React from 'react'
import classes from './BigBox.scss'
import parseHtml from 'html-react-parser'
const Home = props => {
  return (
    <div className={classes.BigBox}>
      <div className={classes.Header}>{props.header}</div>
      <div className={classes.Content}>{parseHtml(props.children)}</div>
    </div>
  )
}
export default Home
